//import Appointment from './appointment/component.vue';
import SearchElements from './search-elements/component.vue';
import CovidCalculator from './covid-calculator/component.vue';

export default {
	//'appointment': Appointment,
	'search-elements': SearchElements,
	'covid-calculator': CovidCalculator
}